// Static section manifest for the Settings sub-nav (US-181).
//
// Order matches the prototype (`prototypes_and_docs/ls-app.jsx:612-619`):
// Profil → Apparence → Notifications → Abonnement → Sécurité → Premiers pas.
//
// 5a.2 owns the AppShell mount of `/settings/*`; this file is the
// canonical map between route segments and the i18n labels the sub-nav
// renders. Both the Settings layout and any breadcrumb consumers should
// read from here.

export interface SettingsSection {
  /** URL segment under `/settings/`. */
  id: 'profile' | 'appearance' | 'notifications' | 'billing' | 'security' | 'start';
  /** i18n key under `settings:nav.<key>`. */
  i18nKey: 'profile' | 'appearance' | 'notifications' | 'billing' | 'security' | 'ftu';
  /** TanStack Router path (relative to the parent layout). */
  path: 'profile' | 'appearance' | 'notifications' | 'billing' | 'security' | 'start';
}

export const SETTINGS_SECTIONS: readonly SettingsSection[] = [
  { id: 'profile', i18nKey: 'profile', path: 'profile' },
  { id: 'appearance', i18nKey: 'appearance', path: 'appearance' },
  { id: 'notifications', i18nKey: 'notifications', path: 'notifications' },
  { id: 'billing', i18nKey: 'billing', path: 'billing' },
  { id: 'security', i18nKey: 'security', path: 'security' },
  { id: 'start', i18nKey: 'ftu', path: 'start' },
] as const;

export const DEFAULT_SETTINGS_SECTION = SETTINGS_SECTIONS[0];
